export const removeSuccessToast = {
  title: '已成功刪除 $t(tracker:displayKind, {"context": "{{context}}" })',
};
